import { ArrowRight } from "lucide-react";
import { fmtDateTime } from "../lib/api";

const LEVELS = ["Supervisor", "H&S Manager", "Site Manager"];

export const EscalationTrail = ({ doc, testid = "escalation-trail" }) => {
  const level = doc.esc_level ?? -1;
  const log = doc.escalation_log || [];
  if (level < 0 && !log.length) return null;
  return (
    <div className="space-y-2 rounded border border-red-500/30 bg-red-500/5 p-3 text-xs" data-testid={testid}>
      <p className="eyebrow">Escalation chain</p>
      <div className="flex flex-wrap items-center gap-1.5">
        {LEVELS.map((l, i) => (
          <span key={l} className="flex items-center gap-1.5">
            <span className={`rounded px-2 py-1 font-semibold transition-colors ${i <= level ? (i === level ? "bg-red-600 text-white" : "bg-red-500/20 text-red-200") : "bg-slate-800 text-slate-500"}`}
              data-testid={`${testid}-level-${i}`}>{l}</span>
            {i < LEVELS.length - 1 && <ArrowRight className="h-3 w-3 text-slate-500" />}
          </span>
        ))}
      </div>
      {doc.esc_next_at && level < 2 && <p className="text-amber-300" data-testid={`${testid}-next`}>Escalates to {LEVELS[level + 1]} at {fmtDateTime(doc.esc_next_at)} if unresolved</p>}
      {log.map((e, i) => <p key={i} className="text-red-200">{e.to} - {e.reason} - {fmtDateTime(e.at)}</p>)}
    </div>
  );
};
